export const WAVEFORMS = [
    '01_Saw',
    '02_Triangle',
    '03_Square',
    '04_Noise',
    '05_Pulse',
    '06_Warm_Saw',
    '07_Warm_Triangle',
    '08_Warm_Square',
    '09_Dropped_Saw',
    '10_Dropped_Square',
    '11_TB303_Square',
    'Bass',
    'Bass_Amp360',
    'Bass_Fuzz_2',
    'Bass_Sub_Dub',
    'Bass_Sub_Dub_2',
    'Brass',
    'Brit_Blues',
    'Brit_Blues_Driven',
    'Buzzy_1',
    'Buzzy_2',
    'Celeste',
    'Chorus_Strings',
    'Dissonant_Piano',
    'Dissonant_1',
    'Dissonant_2',
    'Dyna_EP_Bright',
    'Dyna_EP_Med',
    'Ethnic_33',
    'Full_1',
    'Full_2',
    'Guitar_Fuzz',
    'Harsh',
    'Mkl_Hard',
    'Organ_2',
    'Organ_3',
    'Phoneme_ah',
    'Phoneme_bah',
    'Phoneme_ee',
    'Phoneme_o',
    'Phoneme_ooh',
    'Phoneme_pop_ahhhs',
    'Piano',
    'Putney_Wavering',
    'Throaty',
    'Trombone',
    'Twelve_String_Guitar_1',
    'Twelve_OpTines',
    'Wurlitzer',
    'Wurlitzer_2'
];


const WAVEFORM_CACHE = {};

export const getImaginaryReal = (name) => {
    return new Promise((resolve, reject) => {
        if (name in WAVEFORM_CACHE) {
            resolve(WAVEFORM_CACHE[name]);
            return;
        }
        fetch(window.isNFT ? "waveforms/" + name : '/waveforms/' + name, {
        })
            .then(resp => resp.text())
            .then(resp => {
                let parsed = JSON.parse(resp);
                WAVEFORM_CACHE[name] = parsed;
                resolve(parsed);
            });
    });
};

export const getImaginaryRealSync = (name) => {
    let waveform = WAVEFORM_CACHE[name];
    return waveform;
};


